import * as angular from 'angular';
import template from './deleteDefect.tpl.html';

export interface DeleteDefectData {
  defectName: string;
}

export function openDeleteDefect(data: DeleteDefectData,
                                 $modal: mm.foundation.modal): angular.IPromise<string> {
  return $modal.open({
    template: template,
    controller: 'DeleteDefectCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

export default angular.module('aps.controller.deleteDefect', [])
  .controller('DeleteDefectCtrl', (
    $modalInstance: mm.foundation.modalInstance,
    data: DeleteDefectData
  ) => {
    let vm = {
      defectName: data.defectName,
      comment: null,
      form: <angular.IFormController>null,
      cancel: () => $modalInstance.close(),
      submit: () => {
        if (vm.form.$invalid) {
          return;
        }

        $modalInstance.close(vm.comment);
      }
    };

    return vm;
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/defects/deleteDefect.controller.ts